import * as React from 'react'
import type { SVGProps } from 'react'
const SvgLoader = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={39}
    height={40}
    viewBox="0 0 39 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.5833 1.83335C20.5833 1.32709 20.1729 0.916687 19.6667 0.916687C19.1604 0.916687 18.75 1.32709 18.75 1.83335V9.16669C18.75 9.67295 19.1604 10.0834 19.6667 10.0834C20.1729 10.0834 20.5833 9.67295 20.5833 9.16669V1.83335ZM33.3312 7.79819C33.6892 7.44021 33.6892 6.8598 33.3312 6.50182C32.9732 6.14384 32.3928 6.14384 32.0349 6.50182L26.7182 11.8185C26.3602 12.1765 26.3602 12.7569 26.7182 13.1149C27.0762 13.4728 27.6566 13.4728 28.0146 13.1149L33.3312 7.79819ZM29.75 20.1666C29.75 19.6603 30.1604 19.2499 30.6667 19.2499H38C38.5063 19.2499 38.9167 19.6603 38.9167 20.1666C38.9167 20.6729 38.5063 21.0833 38 21.0833H30.6667C30.1604 21.0833 29.75 20.6729 29.75 20.1666ZM28.0146 27.2184C27.6566 26.8604 27.0762 26.8604 26.7182 27.2184C26.3602 27.5764 26.3602 28.1568 26.7182 28.5147L32.0349 33.8314C32.3928 34.1894 32.9732 34.1894 33.3312 33.8314C33.6892 33.4734 33.6892 32.893 33.3312 32.535L28.0146 27.2184ZM19.6667 30.2499C20.1729 30.2499 20.5833 30.6603 20.5833 31.1666V38.4999C20.5833 39.0062 20.1729 39.4166 19.6667 39.4166C19.1604 39.4166 18.75 39.0062 18.75 38.4999V31.1666C18.75 30.6603 19.1604 30.2499 19.6667 30.2499ZM12.6149 28.5147C12.9729 28.1568 12.9729 27.5764 12.6149 27.2184C12.2569 26.8604 11.6765 26.8604 11.3186 27.2184L6.00188 32.535C5.6439 32.893 5.6439 33.4734 6.00188 33.8314C6.35987 34.1894 6.94027 34.1894 7.29825 33.8314L12.6149 28.5147ZM0.416504 20.1666C0.416504 19.6603 0.82691 19.2499 1.33317 19.2499H8.6665C9.17277 19.2499 9.58317 19.6603 9.58317 20.1666C9.58317 20.6729 9.17277 21.0833 8.6665 21.0833H1.33317C0.82691 21.0833 0.416504 20.6729 0.416504 20.1666ZM7.29825 6.50182C6.94027 6.14384 6.35986 6.14384 6.00188 6.50182C5.6439 6.8598 5.6439 7.44021 6.00188 7.79819L11.3186 13.1149C11.6765 13.4728 12.2569 13.4728 12.6149 13.1149C12.9729 12.7569 12.9729 12.1765 12.6149 11.8185L7.29825 6.50182Z"
      fill="url(#paint0_linear_256_1250)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_256_1250"
        x1={1.59717}
        y1={1.39082}
        x2={10.7376}
        y2={46.0389}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.375} stopColor="#FEBD98" />
        <stop offset={1} stopColor="#4F5277" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgLoader
